import { Order } from "../Model/Order";
import { OrderRepository } from "../Repository/OrderRepository";

export interface GetOrderByIdUseCase {
  invoke: (orderId: number) => Promise<Order | null>;
}

export class GetOrderById implements GetOrderByIdUseCase {
  private repo: OrderRepository;
  constructor(_Repo: OrderRepository) {
    this.repo = _Repo;
  }

   invoke(orderId: number){
    if(!orderId){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
    const getData = this.repo.getOrderById(orderId);
    return getData;
  }
}